import React from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { Loader2 } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { LoginFormProps } from "./types";
import { LoginFormFields } from "./LoginFormFields";
import { useLoginForm } from "./useLoginForm";


const LoginForm: React.FC<LoginFormProps> = ({ onDebugClick }) => {
  const isMobile = useIsMobile();
  const { form, isSubmitting, onSubmit } = useLoginForm();

  return (
    <Card className={`w-full ${isMobile ? 'shadow-lg border-0 rounded-xl max-w-[95%]' : 'max-w-md'}`}>
      <CardHeader className={`text-center ${isMobile ? 'pt-8 pb-4' : ''}`}>
        <div className="flex justify-center mb-6" onClick={onDebugClick}>
          <img 
            src="https://www.luijtenvvz.nl/wp-content/uploads/2025/02/LVVZ-Jubileum-RGB-webshop.svg" 
            alt="Luijten VVZ Logo" 
            className={`${isMobile ? 'h-20' : 'h-24'} w-auto object-contain`} 
          />
        </div>
        <CardTitle className={`${isMobile ? 'text-xl' : 'text-2xl'} font-bold text-black`}>
          Inloggen
        </CardTitle>
        <CardDescription className={isMobile ? 'text-sm' : ''}>
          {isMobile ? 'Log in op de Luijten VVZ app' : 'Voer je gebruikersnaam en wachtwoord in om toegang te krijgen'}
        </CardDescription>
      </CardHeader>
      
      <CardContent className="space-y-4">
        <Form {...form}>
          <form onSubmit={onSubmit} className="space-y-4">
            <LoginFormFields control={form.control} />
            
            <Button 
              type="submit" 
              className={`w-full bg-luijten-red hover:bg-luijten-red/90 ${isMobile ? 'h-12 text-base mt-4 rounded-xl' : ''}`}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Inloggen...
                </>
              ) : "Inloggen"}
            </Button>
          </form>
        </Form>
      </CardContent>
      
      <CardFooter className="text-center text-sm text-muted-foreground pb-6">
        <p className="w-full">{isMobile ? 'V1.0.2' : 'Log in met je persoonlijke gebruikersnaam en wachtwoord'}</p>
      </CardFooter>
    </Card>
  );
};

export default LoginForm;